<!-- Error page-->
<div class="misc-wrapper">
  <a class="brand-logo" href="javascript:void(0);">
    <img src="{{ coreConfig.app.appLogoImage }}" alt="brand-logo" height="28" />
    <h2 class="brand-text text-primary ml-1">{{ coreConfig.app.appName }}</h2></a
  >
  <div class="misc-inner p-2 p-sm-3">
    <div class="w-100 text-center">
      <h2 class="mb-1">Page Non Trouvée 🕵🏻‍♀️</h2>
      <p class="mb-2">Oops! 😖 La page demandée n'a pas été trouvée sur ce serveur.</p>
      <button class="btn btn-primary mb-2 btn-sm-block" (click)="goToDefaultPage()" rippleEffect>
        Retour à l'accueil
      </button>
      <img
        class="img-fluid"
        [src]="
          coreConfig.layout.skin === 'dark'
            ? 'assets/images/pages/error-dark.svg'
            : 'assets/images/pages/error.svg'
        "
        alt="Error page"
      />
    </div>
  </div>
</div>
<!-- / Error page-->
